<template>
  <v-container>
   
      <h2 class="headline font-weight-bold mb-3">
          <v-select
              v-model="site"
          :items="sites"
          label="Select a site"
          dense
          solo
          @change="fillThemes"
        ></v-select>
        </h2>

        <h2 class="headline font-weight-bold mb-3">
          <v-select
              v-model="theme"
          :items="themes"
          label="Select a theme"
          dense
          solo
          @change="fillVariables"
        ></v-select>
        </h2>

        
        <h2 class="headline font-weight-bold mb-3">
          <v-select
              v-model="variable"
          :items="variables"
          label="Select a variable"
          dense
          solo
          @change="displayGraph"
        ></v-select></h2>
        
          <v-row justify="center">
         <v-img
          :src="imagepath"
          aspect-ratio="1.7"
        ></v-img>
        </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'Quicklooks',

    data () {
      return {
        show_tab1: false,
        all: [],
        themes: [],
        variables: [],
        sites: ['sirta', 'p2oa', 'copdd'],
        variable: '',
        site: '',
        theme: '',
        imagepath: ''
      }
    },
    methods: {
      fillVariables: function () {
        this.variables = []
        this.imagepath = ''
        for (let i=0; i<this.all.length; i++)
          {
            if (this.all[i].theme == this.theme)
            this.variables.push(this.all[i].variable)
          }
      },
      fillThemes: function () {
        this.themes = []
        this.variables = []
        this.imagepath = ''
        axios
        .get('https://observations.ipsl.fr/aeris/reobs/data/' + this.site + '/json/quicklooks.json')
        .then(response => {
          this.all = response.data
          for (let i=0; i<response.data.length; i++)
          {
            this.themes.push(response.data[i].theme)
          }
        });
      },
      displayGraph: function () {
        for (let i=0; i<this.all.length; i++)
          {
            if (this.all[i].theme == this.theme && this.all[i].variable == this.variable)
            this.imagepath = 'https://observations.ipsl.fr/aeris/reobs/data/' + this.site + '/figure/ql/' + this.all[i].path;
          }
      }
    },
    mounted() {
      
    }
  }
</script>$
<style scoped>
.container {
padding: 0px;
margin-right: 0;
margin-left: 0;
}
</style>
